module.exports = __webpack_public_path__ + "static/img/login_pic.f1849ca1.png";